<template>
  <div>
    <zj-layout-container>
      <zj-layout-header>
        <div class="listtitle">监控设备</div>
        <el-form
          class="zj-search-form"
          ref="form"
          :model="form"
          :label-width="labelWidth"
        >
          <el-row
            ><el-form-item label="系统角色">
              <el-input v-model="RoleName" disabled></el-input> </el-form-item
          ></el-row>

          <el-form-item label="设备名称" prop="DeviceName">
            <el-input
              v-model="DeviceName"
              placeholder="请输入设备名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="区域">
            <el-select v-model="RegionId" placeholder="请选择">
              <el-option key="" label="全部" value="null"></el-option>
              <el-option
                v-for="item in RegionData"
                :key="item.RegionId"
                :label="item.RegionName"
                :value="item.RegionId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否在线">
            <el-select v-model="IsOnline" placeholder="请选择">
              <el-option key="" label="全部" value="null"></el-option>
              <el-option key="" label="在线" value="true"></el-option>
              <el-option key="" label="离线" value="false"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="设备类型">
            <el-select v-model="DeviceType" placeholder="请选择">
              <el-option key="" label="全部" value="null"></el-option>
              <el-option
                v-for="item in DeviceTypesArr"
                :key="item.Extend1"
                :label="item.Description"
                :value="item.ItemKey"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="" class="right">
            <el-button @click="onSearch">查 询</el-button>
            <el-button @click="toggleAllSelection">全 选</el-button>
            <el-button @click="toggleInverseSelection(tableData)"
              >反 选</el-button
            >
            <el-button @click="onCancel">清 理</el-button>
          </el-form-item>
        </el-form>
        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main>
        <div class="zj-layout-main-content bgcolor scrollable">
          <div
            class="zj-table-container"
            v-loading="syncing"
            :element-loading-text="syncingText"
          >
            <el-table
              v-loading="loading"
              element-loading-text="加载中..."
              :data="tableData"
              ref="multipleTable"
              @selection-change="selectionChange"
              border
              style="width: 100%"
              fixed
            >
              <el-table-column type="selection" width="55"></el-table-column>
              <el-table-column
                prop="DeviceName"
                label="设备名称"
              ></el-table-column>
              <el-table-column prop="RegionName" label="区域">
              </el-table-column>
              <el-table-column
                prop="DeviceType"
                label="设备类型"
                :formatter="getDevicetypeShow"
              >
              </el-table-column>
              <el-table-column prop="Longitude" label="经度" width="140">
              </el-table-column>
              <el-table-column prop="Latitude" label="纬度" width="140">
              </el-table-column>
              <el-table-column prop="IsOnline" label="状态" width="140">
                <template slot-scope="scope">
                  <span v-if="scope.row.IsOnline == false" style="color: red"
                    >离线</span
                  >
                  <span v-if="scope.row.IsOnline == true">在线</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </zj-layout-main>
      <zj-layout-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100,200,500]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="total"
        ></el-pagination>
      </zj-layout-footer>
      <div style="text-align: center">
        <el-button @click="onBack">返回</el-button>
        <el-button @click="onSave" type="primary">提交</el-button>
      </div>
    </zj-layout-container>
  </div>
</template>
<script>
import MyApis from "../../../apis";
import utils from "../../../../../../utils";

export default {
  name: "MonitorDeviceList",
  controller: "UI",
  action: "MonitorDeviceList",
  data() {
    return {
      loading: false, // 搜索中...
      currentPage: 1,
      pageSize: 20,
      total: 0,
      tableData: [],
      RegionData: [],
      EquipmentType: "Monitor", //设备类型
      DeviceId: null,
      DeviceName: null, //设备名称
      RegionId: null, //地区ID
      area: "",
      IsOnline: null, //在线是否
      DeviceType: null,
      DeviceTypesArr: [], //设备类型的数组值
      RoleId: this.$route.query.RoleId,
      RoleName: this.$route.query.RoleName,
      choiceDataList: [],
      selectData: [],
      checkedRows: [],
      mapDeviceId: {},
    };
  },
  created() {
    this.init();
  },
  mounted() {
    this.theme.sidemenu.visiable = false;
    // if (this.$route.query.DeviceId) {
    //   this.search();
    // }
    // if (this.$route.query.type == "look") {
    //   this.IsEdit = false;
    // } else {
    //   this.IsEdit = true;
    // }
    // this.search();
    // this.logInfo.ActionName = "监控设备查询";
    // this.logInfo.LogMessage = "监控设备查询";
    // this.logInfo.ModuleName = "视频监控";
    // this.logInfo.PageName = "监控设备管理列表";
    // this.addOperationLog();
  },
  methods: {
    init() {
      this.loading = true;
      this.loadingText = "加载中...";
      return utils
        .waitAll([
          () => this.getType(),
          () => this.basedataRegion(),
          () => this.getPermissionDevice(),
          () => this.getMonitorDevice(),
        ])
        .then((r) => {
          this.DeviceTypesArr = r[0].JValue;
          this.RegionData = r[1].data.Data;
          this.localRegions = r[1].data.Data.map((x) => {
            return x.RegionId;
          });
          this.defaultRegion = r[1].data.Data.find((x) => {
            if (x.RegionName == "其他" || x.RegionName == "其它") {
              return x;
            }
          });
          this.choiceDataList = r[2].data.Data.PageContents;
          this.tableData = r[3].data.Data.PageContents;
          this.total = r[3].data.Data.BaseSearch.TotalCount;
          this.choiceDataList.forEach((element) => {
            this.mapDeviceId[element.DeviceId] = element;
          });
          this.$nextTick(() => {
            this.tableData.forEach((item) => {
              if (this.mapDeviceId[item.DeviceId]) {
                this.$refs.multipleTable.toggleRowSelection(item, true);
              }
            });
          });

          this.loading = false;
        })
        .catch((e) => {
          this.loading = false;
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    getDevicetypeShow(row, column) {
      let that = this;
      let data = row[column.property];
      if (data) {
        let arr = that.DeviceTypesArr;
        let result = "";
        arr.forEach((item) => {
          if (item.ItemKey == data) {
            result = item.Description;
          }
        });
        return result;
      }
    },
    getMonitorDevice() {
      let searchInfo = {
        EquipmentType: this.EquipmentType, //设备类型
        PageSize: 0,
        PageIndex: 0,
      };
      return new MyApis.MonitorApi().GetEquipmentPagingList(searchInfo);
    },
    getPermissionDevice() {
      let searchInfo = {
        RoleId: this.RoleId,
        PageSize: 0,
        PageIndex: 1,
      };
      return new MyApis.MonitorPermissionApi().GetPageContentByConditions(
        searchInfo
      );
    },
    // 弹出一个错误消息
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox",
      });
    },
    // 表格的选中 可以获得当前选中的数据
    selectionChange(val) {
      // 将选中的数据存储起来
      this.selectData = val;
    },
    search() {
      this.searching = true;
      let online = null;
      if (this.IsOnline == "true") {
        online = true;
      } else if (this.IsOnline == "false") {
        online = false;
      }
      let lookRegionId = this.RegionId;
      if (this.RegionId == "null") {
        lookRegionId = null;
      }
      let dType = this.DeviceType;
      if (this.DeviceType == "null") {
        dType = null;
      }
      let searchInfo = {
        EquipmentType: this.EquipmentType, //设备类型
        DeviceId: this.DeviceId,
        DeviceName: this.DeviceName, //设备名称
        DeviceType: dType,
        DeviceTypes: [],
        RegionId: lookRegionId, //地区ID
        IsOnline: online, //在线是否
        ScenicId: null, //景区ID
        PageSize: this.pageSize,
        PageIndex: this.currentPage,
      };
      new MyApis.MonitorApi()
        .GetEquipmentPagingList(searchInfo)
        .then((r) => {
          //console.log("1");
          this.searching = false;
          r = r.data.Data;
          this.tableData = r.PageContents;
          this.total = r.BaseSearch.TotalCount;
          this.$nextTick(() => {
            this.tableData.forEach((item) => {
              if (this.mapDeviceId[item.DeviceId]) {
                this.$refs.multipleTable.toggleRowSelection(item, true);
              }
            });
          });
        })
        .catch((e) => {
          console.log(e);
          this.searching = false;
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    toggleSelection(rows) {
      console.log(rows);
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row, true);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    clearsearch() {
      this.EquipmentType = null; //设备类型
      this.DeviceId = null;
      this.DeviceName = null; //设备名称
      this.DeviceType = null;

      this.RegionId = null; //地区ID
      this.IsOnline = null; //在线是否
      this.search();
    },
    basedataRegion() {
      let searchInfo = {
        EquipmentType: "Monitor",
        Longitude: 0.0,
        Latitude: 0.0,
      };
      return new MyApis.RegionApi().GetRegionInfos(searchInfo);
    },
    // 点击查询按钮
    onSearch() {
      this.currentPage = 1;
      this.search();
    },
    // 点击取消按钮
    onCancel() {
      this.clearsearch();
    },
    //返回按钮
    onBack() {
      this.$router.go(-1); //返回上一层
    },
    //添加
    onAdd() {
      this.$router.push({
        path: "/plugin/monitor/UI/monitorInfo",
        query: {
          type: "add",
        },
      });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },
    ConvertTranresourcesType(row, column) {
      let data = row[column.property];
      if (data == null) {
        return null;
      }
      let levelstr = this.TranresourcesTypeDic[data];
      return levelstr;
    },
    //日期列表展示格式
    formatDate(row, column) {
      // 获取单元格数据
      let data = row[column.property];
      if (data == null || data == "0001-01-01T00:00:00") {
        return null;
      }
      return new Date(data).format("yyyy-MM-dd hh:mm:ss");
    },
    getType() {
      return this.config.getUValue(":Monitor.DeviceTypes", "");
    },
    onSave() {
      if (this.selectData.length == 0) {
        this.$message({
          type: "info",
          message: "请选择设备",
        });
        return;
      }
      this.saveInfo();
    },
    saveInfo() {
      if (this.RoleId === "") return;
      let MonitorPermisssions = [];
      if (this.choiceDataList.length > 0) {
        let updateResult = [];
        let addResult = [];
       
        let mapA = {};
        let mapB = {};
        // 第一次循环得到id对应的map对象
        this.selectData.forEach((element) => {
          mapA[element.DeviceId] = element;
        });
        //该角色已经添加的设备
        this.choiceDataList.forEach((element) => {
          mapB[element.DeviceId] = element;
        });
        //删除的设备在已选择的choiceDataList中存在，在新选择的设备中不存在
        //新增的设备在choiceDataList中不存在，在新选择的设备中中存在
        //修改的设备在choiceDataList中存在，在新选择的设备中中存在
        this.choiceDataList.forEach((item) => {
          if (!mapA[item.DeviceId]) {
            item.ModifyTime = new Date();
            item.Modifier = ZJApp.ZJUser.current.UserName;
            item.Validity = 1;
            updateResult.push(item);
          }
         
        });

        this.selectData.forEach((item) => {
          let addItem = {};
          if (!mapB[item.DeviceId]) {
            addItem.RoleId = this.RoleId;

            addItem.RoleName = this.RoleName;
            addItem.DeviceId = item.DeviceId;
            addItem.ModifyTime = new Date();
            addItem.Modifier = ZJApp.ZJUser.current.UserName;
            addItem.Validity = 1;
            addItem.CreateTime = new Date();
            addItem.Creater = ZJApp.ZJUser.current.UserName;
            addResult.push(addItem);
          }
        });
      
        MonitorPermisssions = updateResult.concat(addResult);
      } else {
        MonitorPermisssions = this.selectData.map((item) => ({
          RoleId: this.RoleId,
          RoleName: this.RoleName,
          DeviceId: item.DeviceId,
          ModifyTime: new Date(),
          Modifier: ZJApp.ZJUser.current.UserName,
          Validity: 1,
          CreateTime: new Date(),
          Creater: ZJApp.ZJUser.current.UserName,
        }));
      }
      new MyApis.MonitorPermissionApi()
        .UpdateItemList(MonitorPermisssions)
        .then((r) => {
          r = r.data.Data;
          this.$message({
            type: "success",
            message: r ? "保存成功！" : "保存失败！",
          });
          this.loading = false;
          this.logInfo.ActionName = "监控权限添加";
          this.logInfo.LogMessage = r ? "监控权限添加" : "监控权限添加";
          this.logInfo.ModuleName = "监控管理";
          this.logInfo.PageName = "监控权限添加页面";
          this.addOperationLog();
          this.$router.go(-1); //返回上一层
        })
        .catch((e) => {
          this.loading = false;
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    //全选
    toggleAllSelection() {
      this.$refs.multipleTable.toggleAllSelection();
    },
    //反选
    toggleInverseSelection(rows) {
      let checked = this.selectData;
      if (rows) {
        rows.map((row) => {
          checked &&
            checked.map((item) => {
              if (row.Id !== item.Id) {
                this.$refs.multipleTable.toggleRowSelection(item, false);
                this.$refs.multipleTable.toggleRowSelection(row, true);
              } else {
                this.$refs.multipleTable.toggleRowSelection(row, false);
              }
            });
        });
        if (checked.length === 0) {
          rows.forEach((row) => {
            this.$refs.multipleTable.toggleRowSelection(row, true);
          });
        }
      }
    },
  },
  beforeDestroy() {
    this.theme.sidemenu.visiable = true;
  },
};
</script>
